import script from "./InspectorDirectionalLight.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectorDirectionalLight.vue?vue&type=script&setup=true&lang=js"

import "./InspectorDirectionalLight.vue?vue&type=style&index=0&id=7e11bcec&lang=scss&scoped=true"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/3d-editor-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e11bcec"]])

export default __exports__